export default {
  titleWomen: {
    en: 'Skincare-licious!',
  },
  titleMen: {
    en: 'Now On Scentbird!',
  },
  buttonTitle: {
    en: 'Explore Skincare',
  },
  text: {
    en: `
      Your Scentbird subscription just got better.
      <br />
      Starting today you can try FULL-SIZE skincare from top brands - 
      <strong>{gender, select, female {Saturday Skin, Kopari, Glow Recipe}, male {Anthony, Ernest Supplies, Zirh}} & more</strong>  
      - as part of your monthly plan. Discover your next skincare obsession with us.  
      All products are <strong>limited edition</strong>.
    `,
  },
}
